<div class="panel-container-container">
	<div class="panel-container">
		<mat-expansion-panel [expanded]="true" style="height: 100%">
			<mat-expansion-panel-header (click)="containerToggled($event)">
				<mat-panel-title> Device Information </mat-panel-title>
			</mat-expansion-panel-header>
			<div class="table-container">
				<div class="shaded">
					<div>
						<p><app-ellipsis>Device Number</app-ellipsis></p>
					</div>
					<div>
						<p><app-ellipsis>{{
								data && data.CdrDevice && data.CdrDevice.DeviceNum ? data.CdrDevice.DeviceNum : "-"
								}}</app-ellipsis></p>
					</div>
				</div>

				<div>
					<div>
						<p><app-ellipsis>Last IP </app-ellipsis></p>
					</div>
					<div>
						<p><app-ellipsis>{{
								data && data.CdrDevice && data.CdrDevice.LastIP ? data.CdrDevice.LastIP : "-"
								}}</app-ellipsis>
						</p>
					</div>
				</div>

				<div>
					<div>
						<p><app-ellipsis>Device Type </app-ellipsis></p>
					</div>
					<div>
						<p><app-ellipsis>{{
								data && data.CdrDevice && data.CdrDevice.DeviceType
								? data.CdrDevice.DeviceType
								: "-"
								}}
							</app-ellipsis></p>
					</div>
				</div>

				<div class="shaded">
					<div>
						<p><app-ellipsis>Device Status</app-ellipsis> </p>
					</div>
					<div>
						<p><app-ellipsis>{{
								data && data.CdrDevice && data.CdrDevice.DeviceStatus
								? data.CdrDevice.DeviceStatus
								: "-"
								}}</app-ellipsis></p>
					</div>
				</div>

				<div class="shaded">
					<div>
						<p><app-ellipsis>Network Reachable</app-ellipsis></p>
					</div>
					<div>
						<p><app-ellipsis>{{
								data && data.CdrDevice && data.CdrDevice.NetworkReachable ? "Yes" : "No"
								}}</app-ellipsis></p>
					</div>
				</div>

				@if (data.CdrDevice.IsMikrotik) {
				<div>
					<div>
						<p><app-ellipsis>Killswitch Enabled</app-ellipsis> </p>
					</div>
					<div>
						<p><app-ellipsis>{{
								data && data.CdrDevice && data.CdrDevice.KillswitchEnabled ? "Yes" : "No"
								}}</app-ellipsis>
						</p>
					</div>
				</div>
				}

				<div>
					<div>
						<p><app-ellipsis>Last Boot</app-ellipsis></p>
					</div>
					<div>
						<p><app-ellipsis>{{
								data.CdrDevice?.LastBoot ? (data.CdrDevice.LastBoot | date : "yyyy-MM-dd H:mm") : "-"
								}}</app-ellipsis></p>
					</div>
				</div>
			</div>
		</mat-expansion-panel>
	</div>

	@if (data?.CdrDevice?.Customer) {
	<div class="panel-container">
		<mat-expansion-panel [expanded]="true" style="height: 100%">
			<mat-expansion-panel-header (click)="containerToggled($event)">
				<mat-panel-title> Customer Information </mat-panel-title>
			</mat-expansion-panel-header>
			<div class="table-container">
				<div class="shaded">
					<div>
						<p><app-ellipsis>Account Number</app-ellipsis></p>
					</div>
					<div>
						<p><app-ellipsis>{{
								data && data.CdrDevice && data.CdrDevice.Customer
								? data.CdrDevice.Customer.AccountNumber
								: "-"
								}}</app-ellipsis></p>
					</div>
				</div>

				<div>
					<div>
						<p><app-ellipsis>Reference</app-ellipsis></p>
					</div>
					<div>
						<p><app-ellipsis>{{
								data && data.CdrDevice && data.CdrDevice.Customer
								? data.CdrDevice.Customer.Reference
								: "-"
								}}</app-ellipsis>
						</p>
					</div>
				</div>

				<div>
					<div>
						<p><app-ellipsis>Aggregate</app-ellipsis></p>
					</div>
					<div>
						<p><app-ellipsis>
								{{
								data?.CdrDevice?.Customer?.Aggregate?.Description != null
								? data.CdrDevice.Customer.Aggregate.Description
								: "-"
								}}</app-ellipsis></p>
					</div>
				</div>

				<div class="shaded">
					<div>
						<p><app-ellipsis>Status</app-ellipsis></p>
					</div>
					<div>
						<p><app-ellipsis>{{
								data && data.CdrDevice && data.CdrDevice.Customer ? data.CdrDevice.Customer.Status : "-"
								}}</app-ellipsis>
						</p>
					</div>
				</div>

				<div class="shaded">
					<div>
						<p><app-ellipsis>Trading Name</app-ellipsis></p>
					</div>
					<div>
						<p><app-ellipsis>{{
								data && data.CdrDevice && data.CdrDevice.Customer
								? data.CdrDevice.Customer.TradingName
								: "-"
								}}</app-ellipsis></p>
					</div>
				</div>

				<div>
					<div>
						<p><app-ellipsis>HQ Account Number</app-ellipsis></p>
					</div>
					<div>
						<p><app-ellipsis>{{
								data && data.CdrDevice && data.CdrDevice.Customer
								? data.CdrDevice.Customer.HQAccountNumber
								: "-"
								}}</app-ellipsis></p>
					</div>
				</div>
			</div>
		</mat-expansion-panel>
	</div>
	}

	@if (data?.CdrDevice?.SIMs?.length > 0) {

	@for (sim of data.CdrDevice.SIMs; track sim; let i = $index) {
	<div class="panel-container">
		<mat-expansion-panel [expanded]="true" style="height: 100%">
			<mat-expansion-panel-header (click)="containerToggled($event)">
				<mat-panel-title> {{ "Sim " + (i+1) }} </mat-panel-title>
			</mat-expansion-panel-header>
			<div class="table-container">

				<div class="shaded">
					<div>
						<p><app-ellipsis>Sim Number</app-ellipsis></p>
					</div>
					<div>
						<p><app-ellipsis>{{ sim.SimNum ?? "-" }}</app-ellipsis>
						</p>
					</div>
				</div>

				<div>
					<div>
						<p><app-ellipsis>Sim Cell</app-ellipsis></p>
					</div>
					<div>
						<p><app-ellipsis>{{ sim.SimCell ?? "-" }}</app-ellipsis></p>
					</div>
				</div>

				<div>
					<div>
						<p><app-ellipsis>Service Provider</app-ellipsis></p>
					</div>
					<div>
						<p><app-ellipsis> {{ sim.ServiceProvider ?? "-" }}</app-ellipsis></p>
					</div>
				</div>

				<div class="shaded">
					<div>
						<p><app-ellipsis>Disabled</app-ellipsis></p>
					</div>
					<div>
						<p><app-ellipsis>{{ sim.Disabled ?? "-" }}</app-ellipsis>
						</p>
					</div>
				</div>

				<div class="shaded">
					<div>
						<p>APN IP's:</p>
					</div>
					<div>
						<p>-</p>
					</div>
				</div>

				<div>
					<div>
						<p>-</p>
					</div>
					<div>
						<p>-</p>
					</div>
				</div>

				@for (apnInfo of sim.APNInfo; track apnInfo; let j = $index) {
				<div [ngClass]="{'shaded': j % 4 == 1 || j % 4 == 2}">
					<div>
						<p>{{ apnInfo.APN | apnPipe: sim.ServiceProvider }}</p>
					</div>
					<div>
						<p>{{ apnInfo.IP }}</p>
					</div>
				</div>
				}
			</div>
		</mat-expansion-panel>
	</div>

	}
	}

	@if (data?.KaDevice) {
	<div class="panel-container">
		<mat-expansion-panel [expanded]="true" style="height: 100%">
			<mat-expansion-panel-header (click)="containerToggled($event)">
				<mat-panel-title> Keep Alive Information </mat-panel-title>
			</mat-expansion-panel-header>
			<div class="table-container">
				<div class="shaded">
					<div>
						<p><app-ellipsis>Terminal ID</app-ellipsis></p>
					</div>
					<div>
						<p><app-ellipsis>{{
								data && data.KaDevice && data.KaDevice.TerminalID ? data.KaDevice.TerminalID : "-"
								}}</app-ellipsis></p>
					</div>
				</div>

				<div>
					<div>
						<p><app-ellipsis>Terminal Type</app-ellipsis></p>
					</div>
					<div>
						<p><app-ellipsis>{{
								data && data.KaDevice && data.KaDevice.TerminalType ? data.KaDevice.TerminalType : "-"
								}}</app-ellipsis></p>
					</div>
				</div>

				<div>
					<div>
						<p><app-ellipsis>Terminal Supplier</app-ellipsis></p>
					</div>
					<div>
						<p><app-ellipsis>{{
								data && data.KaDevice && data.KaDevice.TerminalSupplier
								? data.KaDevice.TerminalSupplier
								: "-"
								}}</app-ellipsis></p>
					</div>
				</div>

				<div class="shaded">
					<div>
						<p><app-ellipsis>Last Heartbeat</app-ellipsis></p>
					</div>
					<div>
						<p><app-ellipsis>{{
								data && data.KaDevice && data.KaDevice.LastComms
								? (data.KaDevice.LastComms | date : "yyyy-MM-dd H:mm")
								: "-"
								}}</app-ellipsis></p>
					</div>
				</div>

				<div class="shaded">
					<div>
						<p><app-ellipsis>Merchant</app-ellipsis></p>
					</div>
					<div>
						<p><app-ellipsis>{{
								data && data.KaDevice && data.KaDevice.Merchant?.name
								? data.KaDevice.Merchant?.name
								: "-"
								}}</app-ellipsis></p>
					</div>
				</div>

				<div>
					<div>
						<p><app-ellipsis>Acquiring Bank</app-ellipsis></p>
					</div>
					<div>
						<p><app-ellipsis>{{
								data && data.KaDevice && data.KaDevice.AcquiringBank ? data.KaDevice.AcquiringBank : "-"
								}}</app-ellipsis></p>
					</div>
				</div>

				<div>
					<div>
						<p><app-ellipsis>IMEI</app-ellipsis></p>
					</div>
					<div>
						<p><app-ellipsis>{{
								data && data.KaDevice && data.KaDevice.Imei ? data.KaDevice.Imei : "-"
								}}</app-ellipsis></p>
					</div>
				</div>
			</div>
		</mat-expansion-panel>
	</div>
	}

	@if (data?.KaDevice?.AggregatedTowerPing) {
	<div class="panel-container">
		<mat-expansion-panel [expanded]="true" style="height: 100%">
			<mat-expansion-panel-header (click)="containerToggled($event)">
				<mat-panel-title> Keep Alive Heartbeat Information </mat-panel-title>
			</mat-expansion-panel-header>
			<div class="table-container">
				<div class="shaded">
					<div>
						<p><app-ellipsis>First Heartbeat</app-ellipsis></p>
					</div>
					<div>
						<p><app-ellipsis>{{
								data?.KaDevice?.AggregatedTowerPing?.timestamp
								? (data?.KaDevice?.AggregatedTowerPing?.timestamp | date : "yyyy-MM-dd H:mm")
								: "-"
								}}</app-ellipsis></p>
					</div>
				</div>

				<div>
					<div>
						<p><app-ellipsis>Avg Latency</app-ellipsis></p>
					</div>
					<div>
						<p><app-ellipsis>{{
								data?.KaDevice?.AggregatedTowerPing?.avg_latency
								? data?.KaDevice?.AggregatedTowerPing?.avg_latency
								: "-"
								}}</app-ellipsis></p>
					</div>
				</div>

				<div>
					<div>
						<p><app-ellipsis>Min Latency</app-ellipsis></p>
					</div>
					<div>
						<p><app-ellipsis>{{
								data?.KaDevice?.AggregatedTowerPing?.min_latency
								? data?.KaDevice?.AggregatedTowerPing?.min_latency
								: "-"
								}}</app-ellipsis></p>
					</div>
				</div>

				<div class="shaded">
					<div>
						<p><app-ellipsis>Max Latency</app-ellipsis></p>
					</div>
					<div>
						<p><app-ellipsis>{{
								data?.KaDevice?.AggregatedTowerPing?.max_latency
								? data?.KaDevice?.AggregatedTowerPing?.max_latency
								: "-"
								}}</app-ellipsis></p>
					</div>
				</div>

				<div class="shaded">
					<div>
						<p><app-ellipsis>Last Latency</app-ellipsis></p>
					</div>
					<div>
						<p><app-ellipsis>{{
								data?.KaDevice?.AggregatedTowerPing?.last_latency
								? data?.KaDevice?.AggregatedTowerPing?.last_latency
								: "-"
								}}</app-ellipsis></p>
					</div>
				</div>

				<div>
					<div>
						<p>Avg CSQ</p>
					</div>
					<div>
						<p>{{
							data?.KaDevice?.AggregatedTowerPing?.avg_csg
							? data?.KaDevice?.AggregatedTowerPing?.avg_csg
							: "-"
							}}</p>
					</div>
				</div>

				<div>
					<div>
						<p>Last CSQ</p>
					</div>
					<div>
						<p>{{
							data?.KaDevice?.AggregatedTowerPing?.last_csg
							? data?.KaDevice?.AggregatedTowerPing?.last_csg
							: "-"
							}}</p>
					</div>
				</div>

				<div class="shaded">
					<div>
						<p>Sequence Number</p>
					</div>
					<div>
						<p>{{
							data?.KaDevice?.AggregatedTowerPing?.count
							? data?.KaDevice?.AggregatedTowerPing?.count
							: "-"
							}}</p>
					</div>
				</div>

				<div class="shaded">
					<div>
						<p>Total Tx</p>
					</div>
					<div>
						<p>{{
							data?.KaDevice?.AggregatedTowerPing?.total_tx
							? data?.KaDevice?.AggregatedTowerPing?.total_tx
							: "-"
							}}</p>
					</div>
				</div>

				<div>
					<div>
						<p>Avg Tx</p>
					</div>
					<div>
						<p>{{
							data?.KaDevice?.AggregatedTowerPing?.avg_tx
							? data?.KaDevice?.AggregatedTowerPing?.avg_tx
							: "-"
							}}</p>
					</div>
				</div>

				<div>
					<div>
						<p>Total Rx</p>
					</div>
					<div>
						<p>{{
							data?.KaDevice?.AggregatedTowerPing?.total_rx
							? data?.KaDevice?.AggregatedTowerPing?.total_rx
							: "-"
							}}</p>
					</div>
				</div>

				<div class="shaded">
					<div>
						<p>Avg Rx</p>
					</div>
					<div>
						<p>{{
							data?.KaDevice?.AggregatedTowerPing?.avg_rx
							? data?.KaDevice?.AggregatedTowerPing?.avg_rx
							: "-"
							}}</p>
					</div>
				</div>
			</div>
		</mat-expansion-panel>
	</div>
	}

	@if (data?.KaDevice?.AggregatedTowerPing?.CellTower) {
	<div class="panel-container">
		<mat-expansion-panel [expanded]="true" style="height: 100%">
			<mat-expansion-panel-header (click)="containerToggled($event)">
				<mat-panel-title> Current Tower Information </mat-panel-title>
			</mat-expansion-panel-header>
			<div class="table-container">
				<div class="shaded">
					<div>
						<p>Cell ID</p>
					</div>
					<div>
						<p>{{
							data?.KaDevice?.AggregatedTowerPing?.CellTower?.CellID
							? data?.KaDevice?.AggregatedTowerPing?.CellTower?.CellID
							: "-"
							}}</p>
					</div>
				</div>

				<div>
					<div>
						<p>LAC</p>
					</div>
					<div>
						<p>{{
							data?.KaDevice?.AggregatedTowerPing?.CellTower?.LAC
							? data?.KaDevice?.AggregatedTowerPing?.CellTower?.LAC
							: "-"
							}}</p>
					</div>
				</div>

				<div>
					<div>
						<p>MCC</p>
					</div>
					<div>
						<p>{{
							data?.KaDevice?.AggregatedTowerPing?.CellTower?.MCC
							? data?.KaDevice?.AggregatedTowerPing?.CellTower?.MCC
							: "-"
							}}</p>
					</div>
				</div>

				<div class="shaded">
					<div>
						<p>Network</p>
					</div>
					<div>
						<p>{{
							data?.KaDevice?.AggregatedTowerPing?.CellTower?.Network
							? data?.KaDevice?.AggregatedTowerPing?.CellTower?.Network
							: "-"
							}}</p>
					</div>
				</div>

				<div>
					<div>
						<p>Latitude</p>
					</div>
					<div>
						<p>{{
							data?.KaDevice?.AggregatedTowerPing?.CellTower?.Lat
							? data?.KaDevice?.AggregatedTowerPing?.CellTower?.Lat
							: "Unknown"
							}}</p>
					</div>
				</div>

				<div class="shaded">
					<div>
						<p>Tower Status</p>
					</div>
					<div>
						<p>{{ data?.KaDevice?.AggregatedTowerPing?.CellTower?.UnknownTower ? "Unknown" : "Known" }}</p>
					</div>
				</div>

				<div class="shaded">
					<div>
						<p>Longitude</p>
					</div>
					<div>
						<p>{{
							data?.KaDevice?.AggregatedTowerPing?.CellTower?.Long
							? data?.KaDevice?.AggregatedTowerPing?.CellTower?.Long
							: "Unknown"
							}}</p>
					</div>
				</div>
			</div>
		</mat-expansion-panel>
	</div>
	}

	@if (data?.KaDevice?.RingfenceLog) {
	<div class="panel-container">
		<mat-expansion-panel [expanded]="true" style="height: 100%">
			<mat-expansion-panel-header (click)="containerToggled($event)">
				<mat-panel-title> Ringfence Information </mat-panel-title>
			</mat-expansion-panel-header>
			<div class="table-container">
				<div class="shaded">
					<div>
						<p>Date Set</p>
					</div>
					<div>
						<p>{{
							data?.KaDevice?.RingfenceLog?.FormattedTimestamp
							? (data?.KaDevice?.RingfenceLog?.FormattedTimestamp | date : "yyyy-MM-dd H:mm")
							: "-"
							}}</p>
					</div>
				</div>

				<div>
					<div>
						<p>Radius</p>
					</div>
					<div>
						<p>{{
							data?.KaDevice?.RingfenceLog?.Radius ? data?.KaDevice?.RingfenceLog?.Radius + " m" : "-"
							}}</p>
					</div>
				</div>

				<div>
					<div>
						<p>Latitude</p>
					</div>
					<div>
						<p>{{
							data?.KaDevice?.RingfenceLog?.Center ? data?.KaDevice?.RingfenceLog?.Center?.lat : "-"
							}}</p>
					</div>
				</div>

				<div class="shaded">
					<div>
						<p>Longitude</p>
					</div>
					<div>
						<p>{{
							data?.KaDevice?.RingfenceLog?.Center ? data?.KaDevice?.RingfenceLog?.Center?.lng : "-"
							}}</p>
					</div>
				</div>

				<div class="shaded">
					<div>
						<p>Set By</p>
					</div>
					<div>
						<p>{{ data?.KaDevice?.RingfenceLog?.User ? data?.KaDevice?.RingfenceLog?.User : "-" }}</p>
					</div>
				</div>
			</div>
		</mat-expansion-panel>
	</div>
	}

	@if (data?.KaDevice?.DeviceTLSLatestPingPacket) {
	<div class="panel-container">
		<mat-expansion-panel [expanded]="true" style="height: 100%">
			<mat-expansion-panel-header (click)="containerToggled($event)">
				<mat-panel-title> TLS Latest Ping Packet Information </mat-panel-title>
			</mat-expansion-panel-header>
			<div class="table-container">
				<div class="shaded">
					<div>
						<p>Comms</p>
					</div>
					<div>
						<p>{{
							data?.KaDevice?.DeviceTLSLatestPingPacket?.Comms ?
							data?.KaDevice?.DeviceTLSLatestPingPacket?.Comms: "-"
							}}</p>
					</div>
				</div>

				<div>
					<div>
						<p>TLS</p>
					</div>
					<div>
						<p>{{
							data?.KaDevice?.DeviceTLSLatestPingPacket?.TLS ?
							data?.KaDevice?.DeviceTLSLatestPingPacket?.TLS : "-"
							}}</p>
					</div>
				</div>

				<div>
					<div>
						<p>IP Address</p>
					</div>
					<div>
						<p>{{
							data?.KaDevice?.DeviceTLSLatestPingPacket?.IPAddress ?
							data?.KaDevice?.DeviceTLSLatestPingPacket?.IPAddress : "-"
							}}</p>
					</div>
				</div>

				<div class="shaded">
					<div>
						<p>SC ID</p>
					</div>
					<div>
						<p>{{
							data?.KaDevice?.DeviceTLSLatestPingPacket?.SCID ?
							data?.KaDevice?.DeviceTLSLatestPingPacket?.SCID : "-"
							}}</p>
					</div>
				</div>

				<div class="shaded">
					<div>
						<p>Timestamp</p>
					</div>
					<div>
						<p>{{
							data?.KaDevice?.DeviceTLSLatestPingPacket?.Timestamp
							? (data?.KaDevice?.DeviceTLSLatestPingPacket?.Timestamp | date : "yyyy-MM-dd H:mm")
							: "-"
							}}</p>
					</div>
				</div>

				<div class="shaded">
					<div>
						<p>Latency</p>
					</div>
					<div>
						<p>{{ data?.KaDevice?.DeviceTLSLatestPingPacket?.Latency ?
							data?.KaDevice?.DeviceTLSLatestPingPacket?.Latency : "-" }}</p>
					</div>
				</div>

				<div class="shaded">
					<div>
						<p>CSQ</p>
					</div>
					<div>
						<p>{{ data?.KaDevice?.DeviceTLSLatestPingPacket?.CSQ ?
							data?.KaDevice?.DeviceTLSLatestPingPacket?.CSQ : "-" }}</p>
					</div>
				</div>

			</div>
		</mat-expansion-panel>
	</div>
	}


	@for (scheduler of data?.CdrDevice?.DeviceSchedulers; track scheduler) {
	<div class="panel-container">
		<mat-expansion-panel [expanded]="true" style="height: 100%">
			<mat-expansion-panel-header (click)="containerToggled($event)">
				<mat-panel-title> {{ scheduler.SchedulerType.Name }} Device Scheduler Information </mat-panel-title>
			</mat-expansion-panel-header>
			<div class="table-container">
				<div class="shaded">
					<div>
						<p>Status</p>
					</div>
					<div>
						<p>{{ scheduler.Enabled ? "Enabled" : "Disabled" }}</p>
					</div>
				</div>

				<div>
					<div>
						<p>Last Executed</p>
					</div>
					<div>
						<p>{{ scheduler.LastExecuted ? (scheduler.LastExecuted | date : "yyyy-MM-dd H:mm") : "-" }}</p>
					</div>
				</div>

				<div>
					<div>
						<p>Next Execution</p>
					</div>
					<div>
						<p>{{
							scheduler.NextExecution ? (scheduler.NextExecution | date : "yyyy-MM-dd H:mm") : "-"
							}}</p>
					</div>
				</div>

				<div class="shaded">
					<div>
						<p>Interval</p>
					</div>
					<div>
						<p>{{ scheduler.Interval ? scheduler.Interval + " m" : "-" }}</p>
					</div>
				</div>

				<div class="shaded">
					<div>
						<p>Scheduler Type</p>
					</div>
					<div>
						<p>{{ scheduler.SchedulerType ? scheduler.SchedulerType.Name : "-" }}</p>
					</div>
				</div>
			</div>
		</mat-expansion-panel>
	</div>
	}

	@if (data?.CdrDevice?.SnapshotInfo && data?.CdrDevice?.IsMikrotik) {
	<div class="panel-container">
		<mat-expansion-panel [expanded]="true" style="height: 100%">
			<mat-expansion-panel-header (click)="containerToggled($event)">
				<mat-panel-title> Router Information </mat-panel-title>
			</mat-expansion-panel-header>
			<div class="table-container">
				<div class="shaded">
					<div>
						<p>Active VPN</p>
					</div>
					<div>
						<p>{{
							data.CdrDevice.SnapshotInfo?.Details?.ActiveVPN
							? data.CdrDevice.SnapshotInfo.Details.ActiveVPN
							: "-"
							}}</p>
					</div>
				</div>

				<div>
					<div>
						<p>Bridge IP</p>
					</div>
					<div>
						<p>{{
							data.CdrDevice.SnapshotInfo?.Details?.BridgeIP
							? data.CdrDevice.SnapshotInfo.Details.BridgeIP
							: "-"
							}}</p>
					</div>
				</div>

				<div>
					<div>
						<p>Factory Firmware</p>
					</div>
					<div>
						<p>{{
							data.CdrDevice.SnapshotInfo?.Details?.FactoryFirmware
							? data.CdrDevice.SnapshotInfo.Details.FactoryFirmware
							: "-"
							}}</p>
					</div>
				</div>

				<div class="shaded">
					<div>
						<p>Firmware Type</p>
					</div>
					<div>
						<p>{{
							data.CdrDevice.SnapshotInfo?.Details?.FirmwareType
							? data.CdrDevice.SnapshotInfo.Details.FirmwareType + " B"
							: "-"
							}}</p>
					</div>
				</div>

				<div class="shaded">
					<div>
						<p>Identity Name</p>
					</div>
					<div>
						<p>{{
							data.CdrDevice.SnapshotInfo?.Details?.IdentityName
							? data.CdrDevice.SnapshotInfo.Details.IdentityName
							: "-"
							}}</p>
					</div>
				</div>

				<div>
					<div>
						<p>Model</p>
					</div>
					<div>
						<p>{{
							data.CdrDevice.SnapshotInfo?.Details?.Model
							? data.CdrDevice.SnapshotInfo.Details.Model
							: "-"
							}}</p>
					</div>
				</div>

				<div>
					<div>
						<p>Serial Number</p>
					</div>
					<div>
						<p>{{
							data.CdrDevice.SnapshotInfo?.Details?.SerialNumber
							? data.CdrDevice.SnapshotInfo.Details.SerialNumber
							: "-"
							}}</p>
					</div>
				</div>

				<div class="shaded">
					<div>
						<p>Uptime</p>
					</div>
					<div>
						<p>{{
							data.CdrDevice.SnapshotInfo?.Details?.Uptime
							? data.CdrDevice.SnapshotInfo.Details.Uptime
							: "-"
							}}</p>
					</div>
				</div>

				<div class="shaded">
					<div>
						<p>VPN Disconnects</p>
					</div>
					<div>
						<p>{{
							data.CdrDevice.SnapshotInfo?.Details?.VPNDisconnects
							? data.CdrDevice.SnapshotInfo.Details.VPNDisconnects
							: "-"
							}}</p>
					</div>
				</div>

				<div>
					<div>
						<p>WLAN IP</p>
					</div>
					<div>
						<p>{{
							data.CdrDevice.SnapshotInfo?.Details?.WLANIP
							? data.CdrDevice.SnapshotInfo.Details.WLANIP
							: "-"
							}}</p>
					</div>
				</div>

				<div>
					<div>
						<p>Last Updated</p>
					</div>
					<div>
						<p>{{
							data.CdrDevice.SnapshotInfo?.Details?.Timestamp
							? (data.CdrDevice.SnapshotInfo.Details.Timestamp | date : "yyyy-MM-dd H:mm")
							: "-"
							}}</p>
					</div>
				</div>
			</div>
		</mat-expansion-panel>
	</div>
	}

	@if (data?.CdrDevice?.SnapshotInfo?.LTEDetails) {
	<div class="panel-container">
		<mat-expansion-panel [expanded]="true" style="height: 100%">
			<mat-expansion-panel-header (click)="containerToggled($event)">
				<mat-panel-title> LTE Information </mat-panel-title>
			</mat-expansion-panel-header>
			<div class="table-container">
				<div class="shaded">
					<div>
						<p>Access Technology</p>
					</div>
					<div>
						<p>{{
							data.CdrDevice.SnapshotInfo?.LTEDetails?.AccessTechnology
							? data.CdrDevice.SnapshotInfo.LTEDetails.AccessTechnology
							: "-"
							}}</p>
					</div>
				</div>

				<div>
					<div>
						<p>Current Operator</p>
					</div>
					<div>
						<p>{{
							data.CdrDevice.SnapshotInfo?.LTEDetails?.CurrentOperator
							? data.CdrDevice.SnapshotInfo.LTEDetails.CurrentOperator
							: "-"
							}}</p>
					</div>
				</div>

				<div>
					<div>
						<p>IMEI</p>
					</div>
					<div>
						<p>{{
							data.CdrDevice.SnapshotInfo?.LTEDetails?.IMEI
							? data.CdrDevice.SnapshotInfo.LTEDetails.IMEI
							: "-"
							}}</p>
					</div>
				</div>

				<div class="shaded">
					<div>
						<p>Ear FCN</p>
					</div>
					<div>
						<p>{{
							data.CdrDevice.SnapshotInfo?.LTEDetails?.EarFCN
							? data.CdrDevice.SnapshotInfo.LTEDetails.EarFCN
							: "-"
							}}</p>
					</div>
				</div>

				<div class="shaded">
					<div>
						<p>Model</p>
					</div>
					<div>
						<p>{{
							data.CdrDevice.SnapshotInfo?.LTEDetails?.Model
							? data.CdrDevice.SnapshotInfo.LTEDetails.Model
							: "-"
							}}</p>
					</div>
				</div>

				<div>
					<div>
						<p>Pin Status</p>
					</div>
					<div>
						<p>{{
							data.CdrDevice.SnapshotInfo?.LTEDetails?.PinStatus
							? data.CdrDevice.SnapshotInfo.LTEDetails.PinStatus
							: "-"
							}}</p>
					</div>
				</div>

				<div>
					<div>
						<p>Registration Status</p>
					</div>
					<div>
						<p>{{
							data.CdrDevice.SnapshotInfo?.LTEDetails?.RegistrationStatus
							? data.CdrDevice.SnapshotInfo.LTEDetails.RegistrationStatus
							: "-"
							}}</p>
					</div>
				</div>

				<div class="shaded">
					<div>
						<p>Session Uptime</p>
					</div>
					<div>
						<p>{{
							data.CdrDevice.SnapshotInfo?.LTEDetails?.SessionUptime
							? data.CdrDevice.SnapshotInfo.LTEDetails.SessionUptime
							: "-"
							}}</p>
					</div>
				</div>

				<div class="shaded">
					<div>
						<p>UICC</p>
					</div>
					<div>
						<p><app-ellipsis>{{
								data.CdrDevice.SnapshotInfo?.LTEDetails?.UICC
								? data.CdrDevice.SnapshotInfo.LTEDetails.UICC
								: "-"
								}}</app-ellipsis></p>
					</div>
				</div>

				<div>
					<div>
						<p>Enb ID</p>
					</div>
					<div>
						<p>{{
							data.CdrDevice.SnapshotInfo?.LTEDetails?.EnbID
							? data.CdrDevice.SnapshotInfo.LTEDetails.EnbID
							: "-"
							}}</p>
					</div>
				</div>

				<div>
					<div>
						<p>Current CellID</p>
					</div>
					<div>
						<p>{{
							data.CdrDevice.SnapshotInfo?.LTEDetails?.CurrentCellID
							? data.CdrDevice.SnapshotInfo.LTEDetails.CurrentCellID
							: "-"
							}}</p>
					</div>
				</div>

				<div class="shaded">
					<div>
						<p>LAC</p>
					</div>
					<div>
						<p>{{
							data.CdrDevice.SnapshotInfo?.LTEDetails?.LAC
							? data.CdrDevice.SnapshotInfo.LTEDetails.LAC
							: "-"
							}}</p>
					</div>
				</div>

				<div class="shaded">
					<div>
						<p>RSRP</p>
					</div>
					<div>
						<p>{{
							data.CdrDevice.SnapshotInfo?.LTEDetails?.RSRP
							? data.CdrDevice.SnapshotInfo.LTEDetails.RSRP
							: "-"
							}}</p>
					</div>
				</div>

				<div>
					<div>
						<p>RSRQ</p>
					</div>
					<div>
						<p>{{
							data.CdrDevice.SnapshotInfo?.LTEDetails?.RSRQ
							? data.CdrDevice.SnapshotInfo.LTEDetails.RSRQ
							: "-"
							}}</p>
					</div>
				</div>

				<div>
					<div>
						<p>Revision</p>
					</div>
					<div>
						<p>{{
							data.CdrDevice.SnapshotInfo?.LTEDetails?.Revision
							? data.CdrDevice.SnapshotInfo.LTEDetails.Revision
							: "-"
							}}</p>
					</div>
				</div>

				<div class="shaded">
					<div>
						<p>Last Updated</p>
					</div>
					<div>
						<p>{{
							data.CdrDevice.SnapshotInfo?.LTEDetails?.Timestamp
							? (data.CdrDevice.SnapshotInfo.LTEDetails.Timestamp | date : "yyyy-MM-dd H:mm")
							: "-"
							}}</p>
					</div>
				</div>
			</div>
		</mat-expansion-panel>
	</div>
	}

	@if (data?.CdrDevice?.LastPingEvent) {
	<div class="panel-container">
		<mat-expansion-panel [expanded]="true" style="height: 100%">
			<mat-expansion-panel-header (click)="containerToggled($event)">
				<mat-panel-title> Last Ping Information </mat-panel-title>
			</mat-expansion-panel-header>
			<div class="table-container">
				<div class="shaded">
					<div>
						<p>Packet Loss</p>
					</div>
					<div>
						<p>{{
							data.CdrDevice.LastPingEvent?.PacketLoss
							? data.CdrDevice.LastPingEvent?.PacketLoss + " %"
							: "-"
							}}</p>
					</div>
				</div>

				<div>
					<div>
						<p>RTT Min</p>
					</div>
					<div>
						<p>{{ data.CdrDevice.LastPingEvent?.RTTMin ? data.CdrDevice.LastPingEvent?.RTTMin : "-" }}</p>
					</div>
				</div>

				<div>
					<div>
						<p>RTT Max</p>
					</div>
					<div>
						<p>{{ data.CdrDevice.LastPingEvent?.RTTMax ? data.CdrDevice.LastPingEvent?.RTTMax : "-" }}</p>
					</div>
				</div>

				<div class="shaded">
					<div>
						<p>RTT Avg</p>
					</div>
					<div>
						<p>{{ data.CdrDevice.LastPingEvent?.RTTAvg ? data.CdrDevice.LastPingEvent?.RTTAvg : "-" }}</p>
					</div>
				</div>

				<div class="shaded">
					<div>
						<p>RTT Avg Deviation</p>
					</div>
					<div>
						<p>{{ data.CdrDevice.LastPingEvent?.RTTMdev ? data.CdrDevice.LastPingEvent?.RTTMdev : "-" }}</p>
					</div>
				</div>

				<div>
					<div>
						<p>Transmitted</p>
					</div>
					<div>
						<p>{{
							data.CdrDevice.LastPingEvent?.Transmitted
							? data.CdrDevice.LastPingEvent?.Transmitted + " packets"
							: "-"
							}}</p>
					</div>
				</div>

				<div>
					<div>
						<p>Received</p>
					</div>
					<div>
						<p>{{
							data.CdrDevice.LastPingEvent?.Received
							? data.CdrDevice.LastPingEvent?.Received + " packets"
							: "-"
							}}</p>
					</div>
				</div>
			</div>
		</mat-expansion-panel>
	</div>
	}
</div>

<br />